import { render, staticRenderFns } from "./DisplayAdsData.vue?vue&type=template&id=f8f19700"
import script from "./DisplayAdsData.vue?vue&type=script&lang=js"
export * from "./DisplayAdsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports